<app-modal-view
  #modal="modal"
  modalTitle="Simple Payment Calculator">

  <app-simple-payment-container modal-body></app-simple-payment-container>

</app-modal-view>
